// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1dF3K","buttons":"RemoveExpirationActionButtons_buttons__2s-kX"};